import { rehydrateDateAfterJsonization as Q } from "../util/date-utils.js";
export default class ti {
  constructor(t, i, s, l, h) {
    (this.endpoint = t),
      (this.qn = i),
      (this.publicKey = s),
      (this.Vu = l),
      (this.pu = h),
      (this.endpoint = t || null),
      (this.qn = i || null),
      (this.publicKey = s || null),
      (this.Vu = l || null),
      (this.pu = h || null);
  }
  bt() {
    return {
      e: this.endpoint,
      c: this.qn,
      p: this.publicKey,
      u: this.Vu,
      v: this.pu,
    };
  }
  static zn(t) {
    return new ti(t.e, Q(t.c), t.p, t.u, t.v);
  }
}
